import { inject } from '@angular/core';
import {
    Router,
    CanActivateFn,
    ActivatedRouteSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { AppRouterService } from 'src/routing/routes-service';

export const RouteGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const routerService = inject(AppRouterService);

    if (next.routeConfig.path === routerService.componentsUrl.logout) {
        return of(true);
    }

    if (sessionStorage.getItem('gateway-portal-redirect-to-logout') !== null) {
        sessionStorage.removeItem('gateway-portal-redirect-to-logout');
        router.navigate(['/' + routerService.componentsUrl.logout]);
        return of(false);
    }

    return of(true);
};
